import { MapPin, FileCheck2, Clock } from "lucide-react";
import InfoPage from "./InfoPage";

export default function PermitFinder() {
  return (
    <InfoPage
      testid="permit-finder-page"
      eyebrow="Permit Finder"
      title="Every permit you need — in one place"
      description="Search by city or county and instantly see which mobile food permits, fire-safety certificates, and commissary requirements apply to you. Save weeks of phone calls."
      features={[
        {
          testid: "city-coverage",
          icon: <MapPin className="h-5 w-5" />,
          title: "City-by-city coverage",
          description:
            "Real, sourced permit data for the U.S. cities we serve — with direct links to the application portal and estimated fees.",
        },
        {
          testid: "checklist",
          icon: <FileCheck2 className="h-5 w-5" />,
          title: "Personalized checklist",
          description:
            "Tell us your truck type, county, and menu and we'll generate the exact list of permits, inspections, and renewals you need.",
        },
        {
          testid: "renewal-alerts",
          icon: <Clock className="h-5 w-5" />,
          title: "Renewal alerts",
          description:
            "Never lose a day to an expired permit again. We'll email you 30, 14, and 3 days before each one comes up for renewal.",
        },
      ]}
      ctaPrimary={{ label: "Get early access", to: "/register" }}
      ctaSecondary={{ label: "Request your city", to: "/#contact" }}
    />
  );
}
